'use strict'

import Element from './element.js'
import { KeyCode } from '../adapter.js'

let TEXT_INPUT_NICKNAME = ''
let TEXT_LOGIN_BTN = ''

class LoginBoard extends Element {
  constructor (board) {
    super()
    TEXT_INPUT_NICKNAME = board.chatInputPlaceHolder
    TEXT_LOGIN_BTN = '시작하기'
    this.setClass('chat-join-area')
    let wrapper = new Element('div')
    const subTitleEl = document.createElement('p')
    subTitleEl.innerText = board.chatSubTitle
    wrapper.appendElement(subTitleEl)

    let inputWrap = new Element('div')
    inputWrap.setClass('input-wrap')
    let inputInnerWrap = new Element('div')
    let companyNameLabel = new Element('label')
    companyNameLabel.attr('for', 'chat-nickname')
    companyNameLabel.val(board.companyName)
    inputInnerWrap.appendElement(companyNameLabel)
    let $nicknameInput = this.$nickname = new Element('input')
    $nicknameInput.attr('id', 'chat-nickname')
    $nicknameInput.attr('autocomplete', 'off')
    $nicknameInput.attr('type', 'text')
    $nicknameInput.attr('placeholder', TEXT_INPUT_NICKNAME)
    $nicknameInput.setClass('input-style01')
    inputInnerWrap.appendElement($nicknameInput)
    inputWrap.appendElement(inputInnerWrap)
    wrapper.appendElement(inputWrap)
    const spanEl = document.createElement('span')
    spanEl.innerText = board.chatInputExample
    wrapper.appendElement(spanEl)

    const buttonWrap = new Element('div')
    buttonWrap.setClass('button-wrap')
    const $login = this.$login = new Element('button')
    $login.addClass('btn btn-primary')
    $login.appendContent('시작하기')
    wrapper.appendElement($login)
    this.appendElement(wrapper)

    let updateLoginButtonState = () => {
      if (this.$nickname.val().trim()) {
        $login.removeClass('disabled')
      } else {
        $login.addClass('disabled')
      }
    }
    let nicknameEventHandler = (event) => {
      if (event && event.keyCode === KeyCode.ENTER) {
        if (!this.$login.hasClass('disabled')) {
          this.$login.click()
        }
      } else {
        updateLoginButtonState()
      }
    }
    this.$nickname.on('keyup', nicknameEventHandler)
    this.$nickname.on('change', nicknameEventHandler)
  }

  disable () {
    this.$nickname.disable()
    this.$login.addClass('disabled')
  }

  reset () {
    this.$nickname.enable()
    this.$nickname.val('')

    this.$login.val(TEXT_LOGIN_BTN)
    this.toggle(false)
  }

  toggle (isEnabled) {
    if (isEnabled || isEnabled === undefined) {
      this.$login.removeClass('disabled')
      this.$login.setStyle('cursor', '')
    } else {
      this.$login.addClass('disabled')
      this.$login.setStyle('cursor', 'default')
    }
  }

  onLogin (hdlr) {
    this.$login.on('click', hdlr)
  }
}

export { LoginBoard as default }
